import { Field, Float, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { ShippingWeight } from './ShippingWeight'
import { ShippingDimension } from './ShippingDimension'
import { ShippingLabelMessages } from './ShippingLabelMessages'
import { ShippingLabelDownload } from './ShippingLabelDownload'
import { ShippingInsuredValue } from './ShippingInsuredValue'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('ShippingPackageInput')
export class ShippingPackage {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('spkg') })
  _id: string

  @Field(() => ShippingWeight)
  @Prop({ type: ShippingWeight })
  weight: ShippingWeight

  @Field(() => ShippingDimension)
  @Prop({ type: ShippingDimension })
  dimensions: ShippingDimension

  @Field(() => ShippingInsuredValue)
  @Prop({ type: ShippingInsuredValue })
  insured_value: ShippingInsuredValue

  @Field(() => ShippingLabelMessages)
  @Prop({ type: ShippingLabelMessages })
  label_messages: ShippingLabelMessages

  @Field(() => Float)
  @Prop({ type: Number })
  package_id: number

  @Field(() => String)
  @Prop({ type: String })
  package_code: string

  @Field(() => String)
  @Prop({ type: String })
  tracking_number: string

  @Field(() => ShippingLabelDownload)
  @Prop({ type: ShippingLabelDownload })
  label_download: ShippingLabelDownload

  @Field(() => Float)
  @Prop({ type: Number })
  sequence: number

  @Field(() => String)
  @Prop({ type: String })
  trackingUrl: string

  @Field(() => String)
  @Prop({ type: String })
  packageType: string
}
